import React, { useCallback, useState, useRef } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import { Container, Button } from 'react-bootstrap';

import { useToast } from '../../../hooks/toast';
import api from '../../../services/api';

import SelectAsync from '../../SelectAsync';
import InputFake from '../../InputFake';
import Loading from '../../Loading';
import { IDependente } from '../../../pages/CartaoSaudeDetalhe';
import getResponseErrors from '../../../utils/getResponseErrors';

type ComponentProps = {
  PlaCodigo: number;
  updated_at: Date;
  responsavel?: IDependente;
  geraNovoContrato: boolean;
  handleSalvouResponsavel(dados: IDependente[]): void;
  handleRemoveuResponsavel(): void;
};

interface ISubmitForm {
  PacCodigo: string;
}

const CartaoSaudeResponsavel: React.FC<ComponentProps> = ({
  PlaCodigo,
  updated_at,
  responsavel,
  geraNovoContrato,
  handleSalvouResponsavel,
  handleRemoveuResponsavel,
}) => {
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);

  const formRefBusca = useRef<FormHandles>(null);

  const handleSubmitForm = useCallback(
    async (dados: ISubmitForm) => {
      setLoading(true);
      try {
        formRefBusca.current?.setErrors({});
        if (!dados.PacCodigo) {
          formRefBusca.current?.setFieldError(
            'PacCodigo',
            'Selecione o paciente',
          );
          addToast({ type: 'error', title: 'Selecione o paciente' });
          return;
        }

        const response = await api.post<IDependente[]>('planos/responsavel', {
          PlaCodigo,
          PacCodigo: dados.PacCodigo,
          updated_at,
        });

        handleSalvouResponsavel(response.data);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível salvar os dependentes',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [PlaCodigo, updated_at, addToast, handleSalvouResponsavel],
  );

  const handleRemoveResponsavel = useCallback(async () => {
    setLoading(true);
    try {
      await api.delete(
        `planos/responsavel/${PlaCodigo}?updated_at=${updated_at}`,
      );

      handleRemoveuResponsavel();
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Não foi possível excluir o responsável',
        type: 'error',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [PlaCodigo, updated_at, handleRemoveuResponsavel, addToast]);

  return (
    <Container style={{ height: '100%', minHeight: '250px' }}>
      {loading && <Loading />}

      {geraNovoContrato && (
        <div className="alert alert-warning px-3 py-1 mt-2">
          <h5>Atenção!</h5>
          Essa operação írá gerar um novo contrato, começando da parcela 1 até a
          12.
        </div>
      )}

      {responsavel && (
        <div className="border-bottom pb-2 mb-2">
          <InputFake
            label=""
            value={`${responsavel.paciente.PacNome} - CPF ${responsavel.paciente.PacCPFFormatado}`}
          />
          <Button
            type="button"
            size="sm"
            className="mt-2"
            variant="danger"
            onClick={handleRemoveResponsavel}
          >
            Excluir Responsável
          </Button>
        </div>
      )}

      <h6>Escolher um novo responsável</h6>
      <Form ref={formRefBusca} onSubmit={handleSubmitForm}>
        <SelectAsync
          name="PacCodigo"
          label=""
          size="lg"
          urlApi="pacientes/combo?termoBusca="
          placeholder="Digite para buscar"
          handleSelectChange={() => console.log('')}
        />

        <Button type="submit" size="sm" className="mt-2" variant="success">
          Salvar Responsável
        </Button>
      </Form>
    </Container>
  );
};

export default CartaoSaudeResponsavel;
